// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rPg_","rootNoMargin":"styles_rootNoMargin__37Ois"};